// hi
import { PointInteret, Stop, ReservationFormData } from "./types";
import { HOTELS_5_ETOILES } from "./hotels";

// Constantes pour le DatePicker
export const WEEK_DAYS = ["Lun", "Mar", "Mer", "Jeu", "Ven", "Sam", "Dim"];

// Constantes pour le TimePicker
export const HOURS = Array.from({ length: 24 }, (_, i) =>
  i.toString().padStart(2, "0"),
);
export const MINUTES = Array.from({ length: 12 }, (_, i) =>
  (i * 5).toString().padStart(2, "0"),
);

// Points d'intérêt
export const POINTS_INTERET: {
  gares: PointInteret[];
  aeroports: PointInteret[];
  destinations: PointInteret[];
  hotels: PointInteret[];
} = {
  gares: [
    // Gares principales
    // Gares de Cannes (Côte d'Azur)
    {
      id: "CANNES_GARE",
      nom: "Gare de Cannes",
      adresse: "Place de la Gare, 06400 Cannes",
      type: "gare",
      icon: "ph:train",
      pricingZoneId: "CANNES",
      coordinates: {
        lat: 43.553876,
        lon: 7.019303,
      },
    },
    {
      id: "CANNES_LA_BOCCA",
      nom: "Gare de Cannes-la-Bocca",
      adresse: "Avenue de la Gare, 06150 Cannes-la-Bocca",
      type: "gare",
      icon: "ph:train",
      pricingZoneId: "CANNES",
      coordinates: {
        lat: 43.548766,
        lon: 6.986634,
      },
    },
    {
      id: "CANNES_LA_FRAYERE",
      nom: "Gare de La Frayère",
      adresse: "Avenue de la Gare, 06400 Cannes",
      type: "gare",
      icon: "ph:train",
      pricingZoneId: "CANNES",
      coordinates: {
        lat: 43.558085,
        lon: 6.972112,
      },
    },
    {
      id: "CANNES_RANGUIN",
      nom: "Gare de Ranguin",
      adresse: "Avenue de la Gare, 06400 Cannes",
      type: "gare",
      icon: "ph:train",
      pricingZoneId: "CANNES",
      coordinates: {
        lat: 43.569148,
        lon: 6.969311,
      },
    },
  ],
  aeroports: [
    {
      id: "NICE_AIRPORT",
      nom: "Aéroport de Nice",
      adresse:
        "Aéroport Nice Côte d’Azur, Rue Costes et Bellonte, 06206 Nice, France",
      type: "aeroport",
      icon: "ph:airplane",
      pricingZoneId: "NCE_AIRPORT",
      coordinates: {
        lat: 43.6584015,
        lon: 7.2158699,
      },
    },
    {
      id: "CANNES_MANDELIEU",
      nom: "Aérodrome de Cannes Mandelieu",
      adresse: "Aérodrome de Cannes Mandelieu, 06210 Mandelieu-la-Napoule",
      type: "aeroport",
      icon: "ph:airplane",
      pricingZoneId: "CANNES",
      coordinates: {
        lat: 43.54639,
        lon: 6.95417,
      },
    },
    {
      id: "FAYENCE",
      nom: "Aérodrome de Fayence",
      adresse: "Aérodrome de Fayence, 83440 Fayence",
      type: "aeroport",
      icon: "ph:airplane",
      pricingZoneId: "FAYENCE",
      coordinates: {
        lat: 43.60806,
        lon: 6.70167,
      },
    },
    {
      id: "LE_LUC_LE_CANNET",
      nom: "Aérodrome du Luc-Le Cannet",
      adresse: "Aérodrome du Luc-Le Cannet, 83340 Le Luc",
      type: "aeroport",
      icon: "ph:airplane",
      pricingZoneId: "LE_LUC_LE_CANNET",
      coordinates: {
        lat: 43.38472,
        lon: 6.38694,
      },
    },
    {
      id: "LA_MOLE_SAINT_TROPEZ",
      nom: "Aérodrome La Môle – Saint-Tropez",
      adresse: "Aérodrome La Môle, 83310 La Môle",
      type: "aeroport",
      icon: "ph:airplane",
      pricingZoneId: "SAINT_TROPEZ",
      coordinates: {
        lat: 43.20639,
        lon: 6.4825,
      },
    },
    {
      id: "CUERS_PIERREFEU",
      nom: "Aérodrome de Cuers Pierrefeu",
      adresse: "Aérodrome de Cuers Pierrefeu, 83390 Cuers",
      type: "aeroport",
      icon: "ph:airplane",
      pricingZoneId: "CUERS_PIERREFEU",
      coordinates: {
        lat: 43.24759,
        lon: 6.12729,
      },
    },
    {
      id: "HYERES_TOULON",
      nom: "Aéroport Hyères Le Palyvestre / Toulon-Hyères",
      adresse: "Aéroport Hyères Le Palyvestre, 83400 Hyères",
      type: "aeroport",
      icon: "ph:airplane",
      pricingZoneId: "HYERES_TOULON",
      coordinates: {
        lat: 43.09734,
        lon: 6.14603,
      },
    },
  ],
  destinations: [
    {
      id: "MONACO",
      nom: "Monaco",
      adresse: "Monaco",
      type: "destination",
      icon: "ph:map-pin",
      pricingZoneId: "MONACO",
      coordinates: {
        lat: 43.7384,
        lon: 7.4246,
      },
    },
    {
      id: "SAINT_TROPEZ",
      nom: "Saint-Tropez",
      adresse: "Saint-Tropez, 83390",
      type: "destination",
      icon: "ph:map-pin",
      pricingZoneId: "SAINT_TROPEZ",
      coordinates: {
        lat: 43.2694,
        lon: 6.6389,
      },
    },
    {
      id: "ST_JEAN_CAP_FERRAT",
      nom: "Saint-Jean-Cap-Ferrat",
      adresse: "Saint-Jean-Cap-Ferrat, 06230",
      type: "destination",
      icon: "ph:map-pin",
      pricingZoneId: "ST_JEAN_CAP_FERRAT",
      coordinates: {
        lat: 43.6906,
        lon: 7.3331,
      },
    },
    {
      id: "CANNES",
      nom: "Cannes",
      adresse: "Cannes, 06400",
      type: "destination",
      icon: "ph:map-pin",
      pricingZoneId: "CANNES",
      coordinates: {
        lat: 43.5528,
        lon: 7.0174,
      },
    },
  ],
  hotels: HOTELS_5_ETOILES,
};

// Constantes pour le formulaire
export const INITIAL_FORM_DATA: ReservationFormData = {
  departure: "",
  arrival: "",
  date: "",
  time: "",
  passengers: 1,
  luggage: 0,
  babySeats: 0,
  childSeats: 0,
  acceptAnimals: false,
  acceptImmediateRides: true,
  specialRequests: "",
  tripType: "one-way",
  returnDate: "",
  returnTime: "",
  customizeReturn: false,
  stops: [],
  returnArrival: "",
  dispositionDuration: 3,
  // Informations de vol
  departureFlightNumber: "",
  arrivalFlightNumber: "",
  // Informations de train
  departureTrainNumber: "",
  arrivalTrainNumber: "",
  // Types sélectionnés
  selectedDepartureType: null,
  selectedArrivalType: null,
  // Véhicule sélectionné (par défaut Class V)
  selectedVehicleId: "CLASS_V" as const,
};

export const MAX_STOPS = 5;
